module.exports = __webpack_public_path__ + "static/media/SM.c4ee42b3.svg";